import React from 'react';

import SvgContainer from '../SvgContainer';

const Location = () => {
    return (
        <SvgContainer>
            <path d="M8 0C4.68286 0 2 2.504 2 5.6C2 6.992 2.42857 8.296 3.20857 9.472C4.02286 10.704 5.09429 11.76 5.91714 12.992C6.32 13.592 6.61143 14.152 6.92 14.8C7.14286 15.24 7.32286 16 8 16C8.67714 16 8.85714 15.24 9.07143 14.8C9.38857 14.152 9.67143 13.592 10.0743 12.992C10.8971 11.768 11.9686 10.712 12.7829 9.472C13.5714 8.296 14 6.992 14 5.6C14 2.504 11.3171 0 8 0ZM8 7.8C6.81714 7.8 5.85714 6.904 5.85714 5.8C5.85714 4.696 6.81714 3.8 8 3.8C9.18286 3.8 10.1429 4.696 10.1429 5.8C10.1429 6.904 9.18286 7.8 8 7.8Z" />
        </SvgContainer>
    );
};

export default Location;
